import React from "react";
import Icon from "@mdi/react";
import { mdiFileChartOutline, mdiHistory, mdiRefresh } from "@mdi/js";
import { Button } from "@mui/material";
import { ListSidebar } from "layouts";
import { formatClock } from "../taskBoard.utils";
import { SidebarTaskGroup } from "../types";
import styles from "../styles.module.scss";

interface TaskListProps {
	groups: SidebarTaskGroup[];
	selectedTaskId: string | null;
	sidebarSearch: string;
	onSidebarSearch: (value: string) => void;
	onSelectTask: (taskId: string) => void;
	onRefresh: () => void;
	isLoading: boolean;
}

export const TaskList: React.FC<TaskListProps> = ({ groups, selectedTaskId, sidebarSearch, onSidebarSearch, onSelectTask, onRefresh, isLoading }) => {
	return (
		<ListSidebar
			header={
				<div className={styles.sidebarHeader}>
					<div className={styles.sidebarIconWrap}>
						<Icon
							path={mdiHistory}
							size={0.8}
						/>
					</div>
					<div>
						<h3 className={styles.sidebarTitle}>Minhas tarefas</h3>
						<p className={styles.sidebarSubtitle}>Histórico de atividades</p>
					</div>
				</div>
			}
			searchPlaceholder="Pesquisar histórico"
			onSearch={onSidebarSearch}
			footer={
				<Button
					variant="contained"
					fullWidth
					disableElevation
					className={styles.sidebarFooterButton}
					onClick={onRefresh}
					startIcon={
						<Icon
							path={mdiFileChartOutline}
							size={0.75}
						/>
					}
				>
					Gerar relatório
				</Button>
			}
		>
			{isLoading && <p className={styles.sidebarMessage}>Carregando tasks...</p>}

			{!isLoading && groups.length === 0 && <p className={styles.sidebarMessage}>Nenhuma task encontrada.</p>}

			{groups.map((group) => (
				<section
					key={group.key}
					className={styles.sidebarGroup}
				>
					<div className={styles.sidebarGroupLabel}>{group.label}</div>
					{group.tasks.map((task) => (
						<button
							key={task.id}
							type="button"
							onClick={() => onSelectTask(task.id)}
							className={`${styles.sidebarTaskButton} ${selectedTaskId === task.id ? styles.sidebarTaskButtonActive : ""}`}
						>
							<div className={styles.sidebarTaskTopRow}>
								<span className={styles.sidebarTaskDate}>{task.teamName}</span>
								<span className={styles.sidebarTaskTime}>{formatClock(task.updatedAt)}</span>
							</div>
							<p className={styles.sidebarTaskTitle}>{task.objective}</p>
							<div className={styles.sidebarTaskMetaRow}>
								<Icon
									path={mdiRefresh}
									size={0.55}
								/>
								<span>
									{task.completedItems}/{task.totalItems} concluídas
								</span>
							</div>
						</button>
					))}
				</section>
			))}
		</ListSidebar>
	);
};
